import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import injectSheet from 'react-jss'
import pure from 'recompose/pure'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { SELECTOR_LOCATION_LINK_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import MobileDetect from 'aria-viewer/utils/mobileDetect'

const styleSheet = {
    linkContainer: {
        width: '100%',
        height: '100%',
        display: 'inline-block',
        textDecoration: 'none',
        textAlign: 'center',
        color: 'white',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
        borderRadius: 4,
        position: 'relative',
        cursor: 'pointer',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
        backgroundImage: ({ imageSrc }) => `url(${imageSrc})`,
        backgroundSize: ({ aspect }) => {
            switch (aspect) {
                case 'fill':
                    return 'cover'
                case 'fit':
                    return 'contain'
                default:
                    return 'initial'
            }
        },
        border: ({ isMobile, selected }) => (isMobile && selected ? `2px solid ${styleguide.colors.teal}` : 'none'),
    },
    linkOverlay: {
        display: ({ isMobile, selected }) => (isMobile || selected ? 'none' : 'block'),
        transition: 'opacity 0.25s',
        opacity: 0.6,
        background: '#08131e',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 2002,
        '&:hover': {
            opacity: 0,
        },
    },
    mobileLinearGradient: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 4,
        backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6))',
    },
    textContainer: {
        position: 'relative',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2001,
    },
    textLabel: {
        fontWeight: 500,
        fontSize: 32,
        textShadow: '0 2px 6px rgba(0, 0, 0, 0.5)',
    },
}

const LinkContainer = pure(
    injectSheet(styleSheet)(function LinkContainer({
        classes,
        isMobile,
        handleClick,
        to,
        title,
        children,
        aspect,
        selected,
        imageSrc,
    }) {
        return (
            <Link
                className={classes.linkContainer}
                onClick={handleClick}
                to={to}
                tabIndex={SELECTOR_LOCATION_LINK_INDEX}
                title={title}
                replace={true}
            >
                <div className={classes.linkOverlay} alt={title} />

                {isMobile && <div className={classes.mobileLinearGradient} alt={title} />}
                <div className={classes.textContainer} alt={title}>
                    <span className={classes.textLabel}>{title}</span>
                </div>

                {children}
            </Link>
        )
    })
)

const isMobile = MobileDetect.mobile()

class LocationLink extends Component {
    constructor(props) {
        super(props)
    }

    handleClick = e => {
        const { onClick } = this.props

        onClick && onClick(e)
    }

    render() {
        const { to, imageSrc, title, children, aspect, selected } = this.props

        return (
            <LinkContainer
                isMobile={isMobile}
                handleClick={this.handleClick}
                to={to}
                title={title}
                children={children}
                aspect={aspect}
                selected={selected}
                imageSrc={imageSrc}
            />
        )
    }
}

export default LocationLink
